var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"score-info"},[_c('span',{staticClass:"color-meta"},[_vm._v("Трек: "+_vm._s(_vm.track))]),_vm._v(", "),_c('span',{staticClass:"text-bold"},[_vm._v("Баллы: "+_vm._s(_vm.score))]),(_vm.updatedText)?_c('div',{staticClass:"color-meta"},[_vm._v(" Обновлено "+_vm._s(_vm.updatedText)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }